'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bold = exports.borderRadius = exports.colors = exports.typeScale = exports.scale = exports.breakpoints = undefined;

var _palx = require('palx');

var _palx2 = _interopRequireDefault(_palx);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var breakpoints = exports.breakpoints = ['(min-width:40em)', '(min-width:52em)', '(min-width:64em)'].map(function (w) {
  return '@media screen and ' + w;
});

var scale = exports.scale = [0, 8, 16, 32, 64];

var typeScale = exports.typeScale = [64, 48, 32, 24, 16, 14, 12];

var blue = '#07c';

var colors = exports.colors = (0, _util.flattenColors)((0, _palx2.default)(blue));

colors.white = '#fff';

var borderRadius = exports.borderRadius = 2;
var bold = exports.bold = 700;

var defaultConfig = {
  breakpoints: breakpoints,
  scale: scale,
  typeScale: typeScale,
  colors: colors,
  borderRadius: borderRadius,
  bold: bold
};

exports.default = defaultConfig;